import apiClient from '../config/api';

export const getStores = async () => {
    const response = await apiClient.get('/api/stores');
    return response.data;
};

export default {
    getStores,
};
